
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 25.9c5.468 5.467 14.332 5.467 19.8 0 5.467-5.468 5.467-14.332 0-19.8C19.831.634 10.967.634 5.5 6.1m-3.9 9.69h14m-.974 3.375 1.198-3.546-1.239-3.599-1.155-3.4 10 7-10 7 1.197-3.454z","stroke":"currentColor","stroke-width":"2","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    